import { Typography } from "@mui/material"

export const ElementInfoItem = (props) => {

  return (<>
    {props.value && (
      <Typography
        variant="body2"
        gutterBottom
        sx={{
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block',
          maxWidth: '100%'
        }}
      >
        <strong>{props.label}:</strong> {props.value}
      </Typography>
    )}
  </>
  );
};